import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import {
  useAddServiceMutation,
  useUpdateServiceMutation,
} from "../../Data/services/serviceApi";
import { useUploadAttachmentMutation } from "../../Data/services/uploadAttachmentApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import {
  useAddCategoryMutation,
  useUpdateCategoryMutation,
} from "../../Data/services/categoryApi";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import _ from "lodash";
import {
  useAddAdvertisementMutation,
  useUpdateAdvertisementMutation,
} from "../../Data/services/advertisementApi";
import ClipLoader from "react-spinners/ClipLoader";

const EditAdvertisementModal = ({
  handleEditModalClose,
  editData,
  refetch,
}) => {
  const [rowId, setRowId] = useState("");
  const [title, setTitle] = useState();
  const [ctaUrl, setCtaUrl] = useState();
  const [description, setDescription] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const [sending, setSending] = useState(false);

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (editData) {
      console.log(editData);
      setRowId(editData.id);
      setTitle(editData.title || { en: "", ar: "" });
      setImageUrl(editData.image_url);
      setDescription(editData.description || "");
      setCtaUrl(editData.cta_link || "");
      setImagePreview(editData.image_url || "");
    }
  }, [editData, mounted]);

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  const [uploadAttachment, { isLoading: isUploading }] =
    useUploadAttachmentMutation();

  const handleImagePreview = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleImageUpload = async (e) => {
    const formData = new FormData();
    formData.append("file", imageFile);
    formData.append("path", "advertisement");

    // Loop through formData
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    try {
      const response = await uploadAttachment({ formData }).unwrap();
      console.log(response);
      return response.data[0];
    } catch (error) {
      Toast("Failed to upload image", "error");
    }
  };

  const handleDescription = (e) => {
    // console.log(e.target.value);
    setDescription(e.target.value);
  };

  const [addAdvertisement, { isLoading: adding }] =
    useAddAdvertisementMutation();
  const [updateAdvertisement, { isLoading: updating }] =
    useUpdateAdvertisementMutation();

  const handleSubmit = async () => {
    console.log(rowId);
    // console.log(title);
    // console.log(imageUrl);

    setSending(true);
    try {
      let imageName;
      if (imageFile) {
        imageName = await handleImageUpload();
      }

      if (!title || !description || !ctaUrl) {
        Toast("Please fill all the fields", "error");
        setSending(false);
        return;
      }

      const data = {
        title: title,
        description: description,
        cta_link: ctaUrl,
        image_url: (await imageName) || imageUrl || "", // already uploaded image URL
      };

      let response;
      if (editData) {
        response = await updateAdvertisement({ data, id: rowId }).unwrap();
      } else {
        response = await addAdvertisement(data).unwrap();
      }

      console.log(response);

      if (response.code === 200) {
        refetch();
        setSending(false);
        SuccessToast(response?.message);
        handleEditModalClose();
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
      handleEditModalClose();
      setSending(false);
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0 text-black">
              {editData ? "Edit Advertisement" : "Add Advertisement"}
            </p>
            <span className="bg-dark bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleEditModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <Row>
              <Col md={12}>
                <Input
                  classes="mt-2 mb-3"
                  type="text"
                  placeholder="title"
                  value={title}
                  onChange={handleTitleChange}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Input
                  classes="mt-2 mb-3"
                  type="url"
                  placeholder="Enter CTA link"
                  value={ctaUrl}
                  onChange={(e) => {
                    setCtaUrl(e.target.value);
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={9}>
                <Input
                  classes="mt-2 mb-3"
                  type="file"
                  placeholder="Image"
                  onChange={(e) => {
                    // handleImageUpload(e);
                    handleImagePreview(e);
                  }}
                />
              </Col>

              <Col md={3}>
                {isUploading ? (
                  <Spinner />
                ) : (
                  <img
                    src={
                      imagePreview || imageUrl || "https://placehold.co/100x100"
                    }
                    alt="category_image"
                    width={100}
                    height={100}
                    className="rounded"
                  />
                )}
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Input
                  classes="mt-2 mb-3"
                  type="textarea"
                  rows={5}
                  as="textarea"
                  title="answer"
                  placeholder="Enter description"
                  value={description}
                  onChange={handleDescription}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Button
                  classes={`mt-3 mb-2 ${
                    sending || !title || !ctaUrl || !imagePreview
                      ? "bg-dark-subtle"
                      : "shadow"
                  } `}
                  text={
                    sending ? (
                      <ClipLoader color="#6457c6" size="22" />
                    ) : editData ? (
                      "Update"
                    ) : (
                      "Save"
                    )
                  }
                  disabled={sending || !title || !ctaUrl || !imagePreview}
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditAdvertisementModal;
